import moment from 'moment-timezone';

export default (mDate, mTime) =>
  moment(`${mDate.format('YYYY-MM-DD')} ${mTime.format('HH:mm')}`, 'YYYY-MM-DD HH:mm');
